/**
 * Polska odmiana przez liczebnik — jedno miejsce na regułę dla całej aplikacji.
 *
 * Reguła: 1 → forma pojedyncza, końcówka 2–4 (poza przedziałem 12–14) → forma
 * „bliska” (2 pozycje, 3 zmiany), reszta → forma dopełniaczowa (5 pozycji,
 * 5 zmian). Liczby zwykle wynikają z danych, a nie z projektu, więc odmiana
 * musi być policzona przy każdym wystąpieniu.
 *
 * Kategorię wybiera `Intl.PluralRules('pl-PL')`, żeby regułą rządził CLDR,
 * a nie ręczne liczenie końcówek.
 */

// Budowa instancji jest droga, a util leci w pętlach renderujących listy.
const polishPluralRules = new Intl.PluralRules('pl-PL');

/**
 * Sama forma słowa, bez doklejonej liczby — do orzeczeń stojących obok
 * policzonego rzeczownika: „2 pozycje **dotyczą**”, „5 pozycji **przepada**”.
 */
export const pluralForm = (
  count: number,
  one: string,
  few: string,
  many: string,
): string => {
  // `Intl` liczy kategorię z wartości bezwzględnej, więc -3 wychodzi jak 3.
  switch (polishPluralRules.select(count)) {
    case 'one':
      return one;
    case 'few':
      return few;
    // `many` i `other` w jednym. Ułamki wpadają do `other` (`select(1.5)`),
    // a właściwej dla nich formy — dopełniacza liczby pojedynczej („1,5
    // zmiany”) — to API o trzech słowach nie zna. Zostaje dopełniacz mnogi,
    // dokładnie jak w regule sprzed `Intl`; liczniki i tak są całkowite.
    default:
      return many;
  }
};

/**
 * Liczba z odmienionym słowem: `pluralize(3, 'pozycja', 'pozycje', 'pozycji')`
 * → „3 pozycje”.
 */
export const pluralize = (
  count: number,
  one: string,
  few: string,
  many: string,
): string => `${count} ${pluralForm(count, one, few, many)}`;
